import { Star } from 'lucide-react';
import GoogleLogo from '@/components/GoogleLogo';

export default function GoogleReviewsBadge({ variant = 'light', className = '' }) {
  const isLight = variant === 'light';
  return (
    <div className={`inline-flex items-center gap-3 px-4 py-2.5 rounded-full border transition-shadow ${isLight ? 'bg-white border-navy/10' : 'bg-white/10 border-white/15'} ${className}`}>
      <GoogleLogo className="w-5 h-5 flex-shrink-0" />
      <div className="flex items-center gap-1">
        <div className="flex items-center gap-0.5">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={14} className="fill-orange text-orange" />
          ))}
        </div>
      </div>
      <span className={`text-xs ${isLight ? 'text-muted-foreground' : 'text-white/60'}`}>Google Reviews</span>
    </div>
  );
}